import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Contactus extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="contactus" className="a-breadcrumbs">ติดต่อเรา</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div>
                <br/>
                <div className="map-wrapper" style={{height: '400px'}}>
                  {/* <iframe height="400px" width="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.703763947503!2d100.89152389984102!3d13.117943601527346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3102ba0292943771%3A0xeb5570efeba37687!2z4Liq4Liz4LiZ4Lix4LiB4LiH4Liy4LiZ4LmE4LiX4Lii4Lit4Lit4Lii4Lil4LmMIOC4oOC4ueC5hOC4mg!5e0!3m2!1sth!2sth!4v1531452789805" allowFullScreen /> */}
                  <iframe height="400px" width="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3267.55566349198!2d100.91469102418529!3d13.111824858051783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3102b9c3a9e8af11%3A0xab2b2f85f2174d9f!2sThai%20Oil%20Public%20Company%20Limited!5e0!3m2!1sen!2sth!4v1739065971618!5m2!1sen!2sth" allowFullScreen />
                </div>
                <br/>
                <div className="row mt-60">
                  <div className="col-md-6 mb-md-50">
                    <h2 className="mt-0 mb-30">ติดต่อเรา</h2>
                    <hr />
                    <address className="contact-address" style={{fontSize: '20px'}}>
                      <p>&nbsp;&nbsp;<span>Address:</span> 42/1 ม.1 ถนนสุขุมวิท ต.ทุ่งสุขลา อ.ศรีราชา จ.ชลบุรี 20230</p>
                      <p>&nbsp;&nbsp;<span>Phone number:</span> 038-359000 ต่อ 13420 - 13428</p>
                      <p>&nbsp;&nbsp;<span>Email:</span> <a href="mailto:topgroupsavingscoopletter@thaioilgroup.com">topgroupsavingscoopletter@thaioilgroup.com</a></p>
                      <p>&nbsp;&nbsp;<span>Line ID:</span> coop59</p>
                      {/* <p><span>QR Code Line:</span> coop59</p> */}
                      <img src={`${process.env.PUBLIC_URL}/bower_components/img/Board/qrcodelinecoop.png`} width={200} alt="QR Code Line สหกรณ์ออมทรัพย์ไทยออยล์" loading="lazy" />
                    </address>
                    <hr />
                    {/* social icons*/}
                    {/* <a href="#" className="cws-social flaticon-facebook55" />&nbsp;
                    <a href="#" className="cws-social flaticon-twitter1" />&nbsp;
                    <a href="#" className="cws-social fa fa-google-plus" />&nbsp;
                    <a href="#" className="cws-social flaticon-social-network106" />&nbsp;
                    <a href="#" className="cws-social flaticon-pinterest3" /> */}
                    {/* ! social icons*/}
                  </div>
                  {/* <div className="col-md-6">
                    <h2 className="mt-0 mb-30">Send a message</h2>
                    <div className="widget-contact-form pb-0">
                      <div id="feedback-form-errors" role="alert" className="alert alert-danger alt alert-dismissible fade in">
                        <button type="button" data-dismiss="alert" aria-label="Close" className="close"><span aria-hidden="true">×</span></button><i className="alert-icon border flaticon-exclamation-mark1" /><strong>Error Message!</strong><br />
                        <div className="message" />
                      </div>
                      <div className="email_server_responce" />
                        <asp:textbox id="name" size={40} runat="server" placeholder="Your Name" aria-invalid="false" aria-required="true" className="form-row form-row-first" />
                        <asp:textbox id="email" runat="server" size={40} placeholder="Your Email" aria-required="true" className="form-row form-row-last" />
                        <asp:textbox id="message" runat="server" rows={4} placeholder="Your Message" aria-required="true" aria-invalid="false" columns={4} textmode="MultiLine" />
                        <asp:button id="submit" className="cws-button border-radius pull-right" runat="server" text="Send Message" onclick="submit_Click">
                        </asp:button>
                      </div>
                    </div> */}
                  </div>
                </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Contactus;
